import ApplicationFormV2 from '../ApplicationFormV2/ApplicationFormV2';

// V2-only. The legacy Slate-based application-form editor (DocumentContainer)
// was removed; this now always renders the Plate-based ApplicationFormV2.
function ApplicationForm() {
    return <ApplicationFormV2 />;
}

export default ApplicationForm;
